import { registerBlock } from '../../core/registry.js';
import { DividerCanvas, DividerInspector } from './Canvas.jsx';

const definition = {
  type: 'divider',
  schema: {
    defaults: () => ({ style: 'solid', color: '#dee2e6', width: 1 }),
  },
  capabilities: { isContainer: false },
  ui: {
    Canvas: DividerCanvas,
    Inspector: DividerInspector,
    icon: '➖',
    label: 'Divider',
    keywords: ['hr', 'line', 'separator', 'horizontal rule'],
  },
  serialize: (attrs) => {
    const { style = 'solid', color = '#dee2e6', width = 1 } = attrs;
    return `<hr style="border-top:${width}px ${style} ${color};margin:1rem 0;" />`;
  },
};

registerBlock(definition);
export default definition;
